<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import Textarea from '$components/Form/Textarea.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const trainingDomainOptions = [
        `Vente et marketing`,
        `Informatique et bureautique`,
        `Management et leadership`,
        `Tourisme et hôtellerie`,
        `Sécurité, hygiène, santé, QHSE et RSE`,
        `Transport et logistique`,
        `Comptabilité et finance`,
        `Métiers techniques et industriels`,
        `Formation en énergies et environnement`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const mainMotivationOptions = [
        `Obtenir un emploi`,
        `Monter en compétences`,
        `Changer de métier`,
        `Créer ou développer une entreprise`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const professionalSituationOptions = [
        `Étudiant`,
        `En recherche d’emploi`,
        `Salarié`,
        `Entrepreneur`,
        `Une entreprise`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.formationPro.trainingDomain}
        class=""
        let:field
        let:id
        label={`Dans quel domaine souhaitez-vous vous former ?`}
        helpLabel={`Sélectionnez ce choix avec attention, pour que votre demande soit envoyée aux organismes de formation les plus pertinents pour vous`}
        required={false}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={trainingDomainOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.formationPro.mainMotivation}
        class=""
        let:field
        let:id
        label={`Quelle est votre principale motivation pour suivre une formation ?`}
        required={false}
        helpLabel="Plusieurs choix possibles (max 2)"
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            max={2}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={mainMotivationOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.formationPro.professionalSituation}
        class=""
        let:field
        let:id
        label={`Situation professionnelle actuelle, vous êtes :`}
        required={false}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={professionalSituationOptions}
        />
    </Row>

    <Row {form} field={fields.message} label={'Votre demande'} required let:field>
        <p>Précisez votre besoin, soyez le plus précis dans votre demande</p>

        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin, soyez le plus précis dans votre demande`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
